import { VictoryBar } from 'victory';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import floatToCurrency from '../../../../../../utils/floatToCurrency';
import { Card } from './styles';

interface PurchaseCompareCardI {
  before: number;
  after: number;
}

export default function PurchaseCompareCard({
  before,
  after,
}: PurchaseCompareCardI) {
  return (
    <Card>
      <div className="card-title">
        <div>Despesa Inicial X Final</div>
      </div>

      {(!!before && !!after) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryBar
                alignment='middle'
                barRatio={1.8}
                maxDomain={{ x: 2.5 }}
                padding={{ left: 120, top: 40, bottom: 0 }}
                style={{
                  data: { fill: ({ datum }) => datum.x === 'Antes' ? '#c43a31' : '#3ea76a', },
                  parent: { border: 'none' },
                  labels: {
                    fontSize: 22,
                  },
                }}
                categories={
                  { x: ['Antes', 'Depois'] }
                }
                data={[
                  { x: 'Antes', y: before, label: `${floatToCurrency(before)}` },
                  { x: 'Depois', y: after, label: `${floatToCurrency(after)}` }
                ]}
                // animate={{
                //   duration: 5000,
                //   onLoad: { duration: 3000 },
                // }}
              />
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!before) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados de comparativo de compras para o período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
